import { inject, Injectable } from "@angular/core";
import { OF } from "../models/of.model";
import { OfEtat } from "../enums/etat-of.enum";
import { ArticlesInfosFacadeService } from "../../articles/services/article-infos/article-infos-facade.service";
import { ChipState } from "../../../shared/enums/chip-state.enum";

@Injectable({ providedIn: "root" })
export class OfHelperService {
  articleInfosFacade = inject(ArticlesInfosFacadeService);

  static getColorByEtat(e: OfEtat) {
    switch (e) {
      case OfEtat.ANNULE:
        return "var(--color-on-disabled)"; // gris
      case OfEtat.EN_ATTENTE_PROD:
        return "var(--color-tertiary)";
      case OfEtat.EN_PROD:
        return "var(--color-primary)";
      case OfEtat.EN_ATTENTE_BILAN_MATIERE:
      case OfEtat.EN_ATTENTE_REINTE_PDC:
        return "var(--color-on-warning)";
      case OfEtat.EN_ATTENTE_PLANNIF:
        return "var(--color-on-warning2)";
      case OfEtat.EN_ATTENTE_VALIDATION:
        return "var(--color-secondary)";
      case OfEtat.VALIDE:
        return "var(--color-primary)";
    }
  }

  static getStateByEtat(e: OfEtat): ChipState {
    switch (e) {
      case OfEtat.ANNULE:
        return "disabled";
      case OfEtat.EN_ATTENTE_PROD:
        return "pending";
      case OfEtat.EN_PROD:
        return "primary";
      case OfEtat.EN_ATTENTE_BILAN_MATIERE:
      case OfEtat.EN_ATTENTE_REINTE_PDC:
        return "warn";
      case OfEtat.EN_ATTENTE_PLANNIF:
        return "warn-outline";
      case OfEtat.EN_ATTENTE_VALIDATION:
        return "secondary";
      case OfEtat.VALIDE:
        return "valid";
    }
  }

  static getIconByEtat(e: OfEtat) {
    switch (e) {
      case OfEtat.ANNULE:
        return "round_progress_empty";
      case OfEtat.EN_ATTENTE_PROD:
        return "round_progress_quarter";
      case OfEtat.EN_PROD:
        return "round_progress_half";
      case OfEtat.EN_ATTENTE_BILAN_MATIERE:
      case OfEtat.EN_ATTENTE_REINTE_PDC:
        return "round_progress_half";
      case OfEtat.EN_ATTENTE_PLANNIF:
        return "round_progress_quarter";
      case OfEtat.EN_ATTENTE_VALIDATION:
        return "round_progress_full";
      case OfEtat.VALIDE:
        return "round_progress_full";
    }
  }

  static isOfProdEnd(o: OF) {
    if (!o) {
      return true;
    }
    return [
      OfEtat.EN_ATTENTE_REINTE_PDC,
      OfEtat.EN_ATTENTE_VALIDATION,
      OfEtat.EN_ATTENTE_VALIDATION,
      OfEtat.VALIDE,
      OfEtat.ANNULE,
    ].includes(o.etat);
  }

  filterOfByString(search: string) {
    return (of: OF) => {
      return search
        .trim()
        .toLowerCase()
        .split(" ")
        .every(
          (w) =>
            of.numero.toLowerCase().includes(w) ||
            of.ligne.denomination.toLowerCase().includes(w) ||
            of.quantite.toString().includes(w) ||
            of.articleInfos?.denomination?.toLowerCase().includes(w) ||
            of.articleInfos?.code?.toLowerCase().includes(w),
        );
    };
  }
}
